import React, { useEffect, useRef, useState } from "react"
import ContainerMax from "components/shared/ContainerMax"
import { GatsbyImage } from "gatsby-plugin-image"
import ReactPlayer from "react-player"
import Slider from "react-slick"
import styled from "styled-components"

const SliderStyled = styled(Slider)`
 aspect-ratio: 16/9;
`

export default function FullWidthSlider({block}) {
  const { items } = block
  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  const autoplaySpeed = 4000

  const settings = {
    dots: false,
    infinite: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyload: false,
    arrows: false,
    draggable: false,
    swipe: false,
    touchMove: false,
    fade: true,
    // autoplay: true,
    // autoplaySpeed: 4000,
    afterChange: (current) => {
      // Update the current slide index
      setCurrentSlide(current);
    },
  };

  useEffect(() => {
    if (sliderRef.current) {
      // // pause current video as ended 
      // const currentPlayer = document.getElementById(`video-${current}`)?.querySelector('video');
      const player = document.getElementById(`video-${currentSlide}`)?.querySelector('video');
      if (!player) {
        setSlideToMove()
      }
    }
  }, [])

  useEffect(() => {
    if (sliderRef.current) {
      // // pause current video as ended 
      // const currentPlayer = document.getElementById(`video-${current}`)?.querySelector('video');
      const currentPlayer = document.getElementById(`video-${currentSlide}`)?.querySelector('video');

      // if no video set timeout to move after 4s
      if (!currentPlayer) {
        setSlideToMove()
      }
    }
  }, [currentSlide])

  const onVideoEnded = () => {
    // Change to the next slide once the video ends
    if (sliderRef.current) {
      const nextSlide = currentSlide + 1 >= sliderRef.current.props.children.length ? 0 : currentSlide + 1;
      sliderRef.current.slickGoTo(nextSlide);
    }
  };

  const setSlideToMove = () => {
    setTimeout(() => {
      const nextSlide = currentSlide + 1 >= sliderRef.current.props.children.length ? 0 : currentSlide + 1;
      sliderRef.current.slickGoTo(nextSlide);
    }, autoplaySpeed);
  }

  return(
    <ContainerMax 
      maxWidth="1360"
      className="py-4"
    >
      <SliderStyled {...settings} ref={sliderRef}>
        {items?.map((item, i) => {
          return(
            <Item 
              key={`sliderItem${i}`} 
              item={item} 
              id={i} 
              currentSlide={currentSlide} 
              onVideoEnded={onVideoEnded}
            />
          )
        })}
      </SliderStyled>
    </ContainerMax>
  )
}

const Item = ({item, id, currentSlide, onVideoEnded}) => {
  switch (item.content[0]?.__typename) {
    case "WpDefaultTemplate_Acfflexiblecontent_Blocks_FullWidthSlider_items_Content_Video":
      return <Video 
        item={item?.content[0]?.video} 
        id={id} 
        currentSlide={currentSlide} 
        onVideoEnded={onVideoEnded}
      />
  
    default:
      return (
        <div>
          <GatsbyImage image={item?.content[0]?.image.localFile.childImageSharp.gatsbyImageData} alt={item.content[0]?.image.altText} />
        </div>
      )
  }
} 

const Video = ({item, id, currentSlide, onVideoEnded}) => {
  const [playing, setPlaying] = useState(false);
  useEffect(() => {
    if (currentSlide === id) setPlaying(true)
    else setPlaying(false)
  }, [currentSlide]) 

  return(
    <div className="video">
      <ReactPlayer
        id={`video-${id}`}
        url={item}
        controls={false}
        playing={playing}
        muted={true}
        playsinline={true}
        onEnded={onVideoEnded}
        className="embed-responsive embed-responsive-16by9"
        width="100%"
        height="auto"
      />
    </div>
  )
}